export const authDomains: Record<string, string> = {
    "eu-dev": "https://auth-dev.newsafe.org",
    "eu-prod": "https://newsafe.org"
}